import styled from "styled-components";

export const FilterWrapper = styled.div`
  background: #fff;
  padding: 10px;
  border-radius: 10px;

  /* Target the input inside MaterialInputWrapper (which has filterinputbox class) */
  .filterinputbox input {
    width: 300px; /* or whatever width you need */
    max-width: 100%;
    padding: 8px;
    font-size: 14px;
  }

  /* For responsive layout of multiple filters */
  .gap10 {
    flex-wrap: wrap !important;

    & > div {
      min-width: 250px;
      max-width: 500px; /* increase as needed */
      flex: 1 1 250px;
    }
  }
`;
